<template>
  <div
    :class="{ 'main-panel-desktop': $mq !== 'xs' && $mq !== 'sm' && $mq !== 'md' }"
    class="pl-2 pr-1"
  >
    <v-layout row>
      <v-layout row wrap class="align-center">
        <div>
          <div class="display-1">
            {{ current ? current.title : "..." }}
          </div>
        </div>
        <div :class="{ 'ml-5': $mq != 'sm' && $mq != 'md' }">
          <div>
            <v-icon size="1.4rem" color="primary">mail</v-icon>
            {{ current.contactEmail }}
          </div>
          <div>
            <v-icon size="1.4rem" color="primary">phone</v-icon>
            {{ current.contactPhoneNumber }}
          </div>
        </div>
      </v-layout>
      <v-btn
        fixed
        dark
        fab
        right
        style="bottom: 90px;"
        color="accent"
        @click="$emit('displayFloatingWindows')"
        v-if="$mq === 'sm' || $mq === 'xs'"
      >
        <v-icon>chat</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "AnnouncementHeader",
  computed: {
    ...mapState("announcements", ["current"])
  }
};
</script>

<style scoped></style>
